<template>
  <br>
  <p id="rules-label"> {{ ruleLabel }} </p>
  <br>
  <div id="rules-container">
    <ul class="rules-list">
      <li v-for="rule in rules">
        {{ rule }}
      </li>
    </ul>
  </div>
</template>

<script setup>
const ruleLabel = window.PassRulesLabel[0];
const rules = window.PassRules;
</script>

<style scoped>
.rules-list {
  list-style: disc inside;
  position: relative;
  font-size: 14px;
}

#rules-label {
  text-align: left;
  float: left;
  position: absolute;
  font-size: 14px;
}
</style>